import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createStandardAction } from 'typesafe-actions';
import wfeTokenRefresh from '../util/wfeTokenRefresh';
import { selectFilename } from '../selectors/file';
import { selectTraceId, selectUploadSuccessRedirectQueryParams } from '../selectors/upload';
import { getJwt } from '../util/jwtLocalstorage';
import { setFile } from './file';
import { subscribeToChannel } from './pusher';
import { getPaperName, getPublicProxyUrl as getSiteConfigUploadUrl } from '../util/helpers';
import { captureError } from '../util/errors';
import { resetAndInitialize } from './app';
import { CHEGG, CITE_THIS_FOR_ME } from '../types';
export var ActionTypes = {
  UPLOAD_START: 'UPLOAD_START',
  UPLOAD_COMPLETE: 'UPLOAD_COMPLETE',
  UPLOAD_FAILURE: 'UPLOAD_FAILURE',
  UPLOAD_END: 'UPLOAD_END',
  CLOSE_ERROR_MESSAGE: 'CLOSE_ERROR_MESSAGE',
  UPLOAD_RESET: 'UPLOAD_RESET'
};
export var uploadStart = createStandardAction(ActionTypes.UPLOAD_START)();
export var uploadComplete = createStandardAction(ActionTypes.UPLOAD_COMPLETE)();
export var uploadFailed = createStandardAction(ActionTypes.UPLOAD_FAILURE)();
export var uploadEnd = createStandardAction(ActionTypes.UPLOAD_END)();
export var closeErrorMessage = createStandardAction(ActionTypes.CLOSE_ERROR_MESSAGE)();
export var uploadReset = createStandardAction(ActionTypes.UPLOAD_RESET)();
export var fetchUploadUrl = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(proxyApi, headers, uploadId, fileExtension) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch("".concat(proxyApi, "/drCon/uploadUrl/"), {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
              id: uploadId,
              fileExtension: fileExtension
            })
          });
        case 2:
          return _context.abrupt("return", _context.sent);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchUploadUrl(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export var getUploadUrl = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
    var state, uploadId, uploadUrl, authApiUrl, extRegex, fileExtension, headers, response, _yield$response$json, url;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          state = getState();
          uploadId = state.upload.traceId;
          uploadUrl = getSiteConfigUploadUrl(state.site);
          authApiUrl = state.authApiUrl;
          if (uploadId) {
            _context2.next = 6;
            break;
          }
          throw new Error('No Upload ID');
        case 6:
          extRegex = /(?:\.([^.]+))?$/;
          if (state.file) {
            fileExtension = extRegex.exec(state.file.name);
          }
          if (fileExtension) {
            _context2.next = 10;
            break;
          }
          throw new Error('No File Extension');
        case 10:
          _context2.prev = 10;
          headers = {
            'chegg-wfe-token': "Bearer ".concat(getJwt()),
            'Wtai-Trace-Id': uploadId,
            'Content-Type': 'application/json'
          };
          _context2.next = 14;
          return fetchUploadUrl(uploadUrl, headers, uploadId, fileExtension[1]);
        case 14:
          response = _context2.sent;
          if (!(response.status !== 200)) {
            _context2.next = 22;
            break;
          }
          _context2.next = 18;
          return wfeTokenRefresh(authApiUrl, response, state.onAuthUpdate);
        case 18:
          headers['chegg-wfe-token'] = "Bearer ".concat(getJwt());
          _context2.next = 21;
          return fetchUploadUrl(uploadUrl, headers, uploadId, fileExtension[1]);
        case 21:
          response = _context2.sent;
        case 22:
          _context2.next = 24;
          return response.json();
        case 24:
          _yield$response$json = _context2.sent;
          url = _yield$response$json.data;
          return _context2.abrupt("return", url);
        case 29:
          _context2.prev = 29;
          _context2.t0 = _context2["catch"](10);
          captureError(_context2.t0);
          throw new Error('Failed to get S3 URL');
        case 33:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[10, 29]]);
  }));
  return function getUploadUrl(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
export var onSuccessFactory = function onSuccessFactory(getState, dispatch, uploadId, filename, redirectQueryParams, editorBaseUrl, onUploadSuccess) {
  var token = getJwt();
  var successRedirect = function successRedirect() {
    var config = getState();
    var path = config.site === CHEGG ? '/draft' : "/edit/".concat(uploadId, "/");
    var queryParams = _objectSpread(_objectSpread({}, config.site === CHEGG ? {
      uploadId: uploadId
    } : {
      token: token,
      runChecks: 'true'
    }), {}, {
      filename: filename
    }, redirectQueryParams);
    var redirectUrl = "".concat(editorBaseUrl).concat(path, "?").concat(new URLSearchParams(queryParams));
    if (config.site == CITE_THIS_FOR_ME) {
      window.open(redirectUrl, '_blank');
      dispatch(resetAndInitialize());
    } else {
      window.location.assign(redirectUrl);
    }
  };
  if (onUploadSuccess) {
    // If passed in as a prop, call this rather
    //  than redirect.
    return onUploadSuccess({
      id: uploadId,
      filename: filename,
      redirect: successRedirect
    });
  }
  return successRedirect();
};
export var uploadSuccess = function uploadSuccess(url) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState, _ref3) {
      var pusherClient, state, filename, uploadId, redirectQueryParams, editorBaseUrl, onUploadSuccess, fileContents;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            pusherClient = _ref3.pusherClient;
            state = getState();
            filename = selectFilename(state);
            uploadId = selectTraceId(state);
            redirectQueryParams = selectUploadSuccessRedirectQueryParams(state);
            editorBaseUrl = state.editorBaseUrl, onUploadSuccess = state.onUploadSuccess;
            _context3.prev = 6;
            _context3.next = 9;
            return downloadTextFromUrl(url);
          case 9:
            fileContents = _context3.sent;
            if (fileContents) {
              dispatch(uploadEnd({
                text: fileContents,
                filename: filename,
                uploadId: uploadId
              }));
              onSuccessFactory(getState, dispatch, uploadId, filename, redirectQueryParams, editorBaseUrl, onUploadSuccess);
            }
            _context3.next = 18;
            break;
          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](6);
            dispatch(uploadFailed());
            captureError(_context3.t0);
            pusherClient.unsubscribe();
          case 18:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[6, 13]]);
    }));
    return function (_x7, _x8, _x9) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var convertToFile = function convertToFile(content, isResubmit, filename) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var blob, name, file;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            blob = new Blob([content], {
              type: 'text/plain'
            });
            name = getPaperName(isResubmit, filename);
            file = Object.assign(blob, {
              name: name,
              lastModified: new Date()
            });
            dispatch(setFile(file));
            dispatch(subscribeToChannel());
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x10) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var uploadToS3 = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, _, _ref6) {
    var pusherClient, _ref8, url;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          pusherClient = _ref6.pusherClient;
          _context5.prev = 1;
          _context5.next = 4;
          return dispatch(getUploadUrl);
        case 4:
          _ref8 = _context5.sent;
          url = _ref8.url;
          _context5.next = 8;
          return dispatch(putToS3(url));
        case 8:
          dispatch(uploadComplete());
          _context5.next = 16;
          break;
        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](1);
          dispatch(uploadFailed());
          captureError(_context5.t0);
          pusherClient.unsubscribe();
        case 16:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[1, 11]]);
  }));
  return function uploadToS3(_x11, _x12, _x13) {
    return _ref7.apply(this, arguments);
  };
}();
export var putToS3 = function putToS3(url) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      var file;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            file = getState().file;
            _context6.next = 4;
            return fetch(url, {
              method: 'PUT',
              body: file
            });
          case 4:
            _context6.next = 10;
            break;
          case 6:
            _context6.prev = 6;
            _context6.t0 = _context6["catch"](0);
            console.log('Error with putToS3:', _context6.t0);
            throw _context6.t0;
          case 10:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 6]]);
    }));
    return function (_x14, _x15) {
      return _ref9.apply(this, arguments);
    };
  }();
};
export var downloadTextFromUrl = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(url) {
    var response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return fetch(url);
        case 3:
          response = _context7.sent;
          _context7.next = 6;
          return response.text();
        case 6:
          return _context7.abrupt("return", _context7.sent);
        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](0);
          console.log('Error downloading document', _context7.t0);
          throw _context7.t0;
        case 13:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 9]]);
  }));
  return function downloadTextFromUrl(_x16) {
    return _ref10.apply(this, arguments);
  };
}();
var SET_TRACE_ID = 'SET_TRACE_ID';
export var setTraceId = createStandardAction(SET_TRACE_ID)();